import { render, staticRenderFns } from "./DialogConfirmarCancelamento.vue?vue&type=template&id=1c231728&scoped=true"
import script from "./DialogConfirmarCancelamento.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogConfirmarCancelamento.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c231728",
  null
  
)

export default component.exports